import { FlatSidebarMenuItem } from '@/components/ui/FlatSidebarMenu'
import { AgentIcon, WorkspaceIcon } from '@/const'
import { IconDatabricksOutline } from '@icons/IconDatabricksOutline'
import { IconServiceOutline } from '@icons/IconServiceOutline'
import { IconV2FolderOutline } from '@icons/IconV2FolderOutline'
// import { IconV2SettingsOutline } from '@icons/IconV2SettingsOutline'

export function getProjectNavigation(showDmpChat: boolean): FlatSidebarMenuItem[] {
  return [
    { title: 'Overview', Icon: WorkspaceIcon, path: '.', visible: true },
    { title: 'DMP Chat', Icon: AgentIcon, path: 'chat', visible: showDmpChat },
    { title: 'Agent Skills', Icon: IconServiceOutline, path: 'agent-skills', visible: showDmpChat },
    { title: 'Databricks', Icon: IconDatabricksOutline, path: 'databricks', visible: true },
    { title: 'File Manager', Icon: IconV2FolderOutline, path: 'file-manager', visible: true },
    // { title: 'Settings', Icon: IconV2SettingsOutline, path: 'settings', visible: true },
  ]
}

export function getProjectQuickLinks(showDmpChat: boolean): FlatSidebarMenuItem[] {
  return getProjectNavigation(showDmpChat).filter((item) => item.path !== '.' && (item.visible ?? true))
}

export function getProjectQuickLinkPath(projectId: number, path: string) {
  return `/projects/${projectId}/${path}`
}
